import { getUserDetails } from "../config";
export const NEW_TASK_TEMPLATE = {
  name: "",
  category: "",
  retryCount: 3,
  description:
    "Edit or extend this sample task. Set the task name to get started",
  timeoutSeconds: 3600,
  timeoutPolicy: "TIME_OUT_WF",
  retryLogic: "FIXED",
  retryDelaySeconds: 60,
  responseTimeoutSeconds: 600,
  rateLimitPerFrequency: 0,
  rateLimitFrequencyInSeconds: 1,
  ownerEmail: "",
  inputTemplate: {},
  inputKeys: [],
  outputKeys: [],
  noRetryOn: [],
  retryOn: [],
  concurrentExecLimit: 100,
  pollTimeoutSeconds: 1200,
};

export function configureMonaco(monaco) {
  // No-op
}

export const taskFields = [
  // Basic Settings
  {
    fieldLabel: "Name",
    field: "name",
    fieldType: "Text",
    isMandatory: "Yes",
    path: "root",
    active: "True",
    hide: "False",
    groupName: "Basic settings",
  },
  {
    fieldLabel: "Type",
    field: "category",
    fieldType: "Select",
    defaultValue: "",
    isMandatory: "Yes",
    path: "root",
    active: "True",
    hide: "False",
    options: [],
    groupName: "Basic settings",
  },
  {
    fieldLabel: "Description",
    field: "description",
    fieldType: "textarea",
    isMandatory: "Yes",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue:
      "Edit or extend this sample task. Set the task name to get started",
    groupName: "Basic settings",
  },
  {
    fieldLabel: "Owner Email",
    field: "ownerEmail",
    fieldType: "Text",
    isMandatory: "Yes",
    path: "root",
    active: "True",
    hide: "True",
    groupName: "Basic settings",
  },

  // Rate Limit Settings
  {
    fieldLabel: "Rate limit per frequency",
    field: "rateLimitPerFrequency",
    fieldType: "Text",
    defaultValue: 0,
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    groupName: "Rate Limit Settings",
  },
  {
    fieldLabel: "Frequency seconds",
    field: "rateLimitFrequencyInSeconds",
    fieldType: "Text",
    defaultValue: 1,
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    groupName: "Rate Limit Settings",
  },
  {
    fieldLabel: "Number of concurrent tasks that can be executed",
    field: "concurrentExecLimit",
    fieldType: "Text",
    defaultValue: 100,
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    groupName: "Rate Limit Settings",
  },

  // Retry settings
  {
    fieldLabel: "No. of times to retry the task upon failure?",
    field: "retryCount",
    fieldType: "Text",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue: 3,
    tooltip:
      "The number of retries to attempt when a task fails. The default value is 3.",
    groupName: "Retry settings",
  },
  {
    fieldLabel: "With a delay in seconds",
    field: "retryDelaySeconds",
    fieldType: "Text",
    defaultValue: 60,
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    tooltip:
      "Indicates the time (in seconds) to wait before each retry occurs. The default value is 60.",
    groupName: "Retry settings",
  },
  {
    fieldLabel: "Retry policy",
    field: "retryLogic",
    fieldType: "Select",
    defaultValue: "FIXED",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    options: [
      {
        value: "FIXED",
        key: "Fixed",
      },
      {
        value: "LINEAR_BACKOFF",
        key: "Linear Backoff",
      },
      {
        value: "EXPONENTIAL_BACKOFF",
        key: "Exponential Backoff",
      },
    ],
    tooltip: "Indicates the mechanism for the retries",
    groupName: "Retry settings",
  },

  // Timeout settings
  {
    fieldLabel: "Overall task timeout in seconds?",
    field: "timeoutSeconds",
    fieldType: "Text",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue: 3600,
    tooltip:
      "After which the task is marked as TIMED_OUT if not completed after transitioning to IN_PROGRESS status for the first time. No timeout occurs if the value is set to 0.",
    groupName: "Timeout settings",
  },
  {
    fieldLabel: "Task poll timeout in seconds?",
    field: "pollTimeoutSeconds",
    fieldType: "Text",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue: 3600,
    tooltip:
      "After which the task is marked as TIMED_OUT if not polled by a worker. No timeout occurs if the value is set to 0.",
    groupName: "Timeout settings",
  },
  {
    fieldLabel: "Timeout policy (Action when a task times out)",
    field: "timeoutPolicy",
    fieldType: "Select",
    defaultValue: "TIME_OUT_WF",
    isMandatory: "No",
    path: "root",
    active: "True",
    tooltip: "Indicates the condition at which the task should time out.",
    hide: "False",
    options: [
      {
        value: "TIME_OUT_WF",
        key: "Timeout Workflow",
      },
      {
        value: "RETRY",
        key: "Retry Task",
      },
      {
        value: "ALERT_ONLY",
        key: "Alert Only",
      },
    ],
    groupName: "Timeout settings",
  },
  {
    fieldLabel: "Task response timeout for each invocation in seconds",
    field: "responseTimeoutSeconds",
    fieldType: "Text",
    defaultValue: 600,
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    tooltip:
      "Set a time (in seconds) to reschedule the task if the task status is not updated. Default value is 3600.",
    groupName: "Timeout settings",
  },

  // Task Imput template
  {
    fieldLabel:
      "These values will be supplied to each execution of the task and can be overridden within a workflow",
    field: "inputTemplate",
    fieldType: "inputParams",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue: {},
    tooltip: "",
    groupName: "Task Input template",
    groupWidth: "100%",
  },

  // Input Keys
  {
    fieldLabel:
      "These values serves as an indicator of what inputs this task expects",
    field: "inputKeys",
    fieldType: "keyParams",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue: [],
    tooltip: "",
    groupName: "Input Keys",
    groupWidth: "100%",
  },

  // Output Keys
  {
    fieldLabel:
      "These values serves as an indicator of what outputs this task will produce",
    field: "outputKeys",
    fieldType: "keyParams",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue: [],
    tooltip: "",
    groupName: "Output Keys",
    groupWidth: "100%",
  },

  {
    fieldLabel: "Values that indicate when retries should not occur",
    field: "noRetryOn",
    fieldType: "keyParams",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue: [],
    tooltip: "",
    groupName: "No Retry On",
    groupWidth: "100%",
  },

  {
    fieldLabel: "Values that indicate when retries should occur",
    field: "retryOn",
    fieldType: "keyParams",
    isMandatory: "No",
    path: "root",
    active: "True",
    hide: "False",
    defaultValue: [],
    tooltip: "",
    groupName: "Retry On",
    groupWidth: "100%",
  },
];
